import { render, staticRenderFns } from "./QuoteForm.vue?vue&type=template&id=31ed6e28&scoped=true&"
import script from "./QuoteForm.vue?vue&type=script&lang=js&"
export * from "./QuoteForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ed6e28",
  null
  
)

export default component.exports